module.exports = __webpack_public_path__ + "static/img/ent-11.ddb720f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-11.jpg
// module id = xB/6
// module chunks = 51